import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownService } from 'src/app/metricas/service/dropdown-metricas.service';
import { MetricasService } from 'src/app/metricas/service/metricas.service';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filtro-tipo-obra',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './filtro-tipo-obra.component.html',
  styleUrls: ['./filtro-tipo-obra.component.scss'],
})
export class FiltroTipoObraComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;



  @Input() tiposObra: { moduleID: number; module: string }[] = [
    { moduleID: 234, module: 'Imobili\u00E1rio' },
    { moduleID: 6, module: 'Edifica\u00E7\u00F5es' },
    { moduleID: 5, module: 'Industrial' },
    { moduleID: 7, module: 'Infraestrutura' },
  ];

  mostrarTipoObra = false;
    @Input() filtroTipoObraSelecionados: number[] = [];

  @Output() tiposSelecionadosChange = new EventEmitter<number[]>();

  constructor(
    private dropdownService: DropdownService
  ) {}

  ngOnInit() {
    this.dropdownService.getActiveDropdown().subscribe((active) => {
      if (active !== 'tipoObra') {
        this.mostrarTipoObra = false;
      }
    });
  }

  toggleTipoObra() {
    const isOpening = !this.mostrarTipoObra;
    this.dropdownService.setActiveDropdown(isOpening ? 'tipoObra' : null);
    this.mostrarTipoObra = isOpening;
  }

  limparTiposObra() {
    this.filtroTipoObraSelecionados = [];
    this.mostrarTipoObra = false;
    this.tiposSelecionadosChange.emit(this.filtroTipoObraSelecionados);
  }


  onTipoObraChange(): void {
    this.mostrarTipoObra = false;
    this.dropdownService.setActiveDropdown(null);
  }

  onTipoObraToggle(tipoId: number, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;

    if (isChecked) {
      if (!this.filtroTipoObraSelecionados.includes(tipoId)) {
        this.filtroTipoObraSelecionados.push(tipoId);
      }
    } else {
      this.filtroTipoObraSelecionados = this.filtroTipoObraSelecionados.filter(
        (id) => id !== tipoId
      );
    }

    this.mostrarTipoObra = false;
    this.tiposSelecionadosChange.emit(this.filtroTipoObraSelecionados);
  }
}
